/**
 * NE4: AUFTRAG AN TELEKOM MELDEN (.620).
 *
 * ORIGINALTEXT MARVIN (03.11.2026)
 *   „Und dann würde ich einen Button haben, Auftrag an Postfach der Telekom melden. Standardtext oder mit zwei,
 *    drei Vorlagen hier. Kunde verweigert, Kunde hat bereits Vorlaufsklausel Kunde hat storniert oder was auch
 *    immer. Und so die E-Mail. Die E-Mail als Anlage beigefügt haben. Als Anhang mit rein. Und dann soll es
 *    geschickt werden." „soll dann auf zurückgegeben gehen."
 *
 * Vorlage wählen, Betreff und Text ändern, Anhänge ankreuzen (Kundenmails vorausgewählt), Senden. Die Adresse
 * des Postfachs zeigt das Fenster nicht; sie steht in der Konfiguration. Kein Browser-Popup, alles im Fenster.
 */
import { useEffect, useState } from 'react';
import { api, zeitpunkt } from '../api.ts';
import { Dialog, Fehlerkasten, Text, ausFehler, type Fehlerlage } from './Formular.tsx';

const mb = (b: number) => (b >= 1048576 ? `${(b / 1048576).toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round(b / 1024))} kB`);

export function TelekomMeldung({ a, zu, fertig }: { a: any; zu: () => void; fertig: (karte: any, text: string) => void }) {
  const [d, setD] = useState<any>(null);
  const [vorlage, setVorlage] = useState('');
  const [betreff, setBetreff] = useState('');
  const [text, setText] = useState('');
  const [wahl, setWahl] = useState<Set<string>>(new Set());
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const [vorschau, setVorschau] = useState(false);

  useEffect(() => {
    api.ne4TelekomVorlagen(a.id).then((x: any) => {
      setD(x);
      const erste = x.vorlagen[0];
      if (erste) { setVorlage(erste.schluessel); setBetreff(erste.betreff); setText(erste.text); }
      setWahl(new Set(x.dateien.filter((f: any) => f.vorgewaehlt).map((f: any) => f.id)));
    }).catch((f) => setFehler(ausFehler(f)));
  }, [a.id]);

  const nimmVorlage = (s: string) => {
    const v = d?.vorlagen.find((x: any) => x.schluessel === s);
    if (!v) return;
    setVorlage(s); setBetreff(v.betreff); setText(v.text);
  };
  const gewaehlt = (d?.dateien ?? []).filter((f: any) => wahl.has(f.id));
  const summe = gewaehlt.reduce((s: number, f: any) => s + Number(f.groesse ?? 0), 0);
  const zuGross = !!d && summe > d.hoechstens;

  async function senden() {
    setLaeuft(true); setFehler(null);
    try {
      const r = await api.ne4TelekomMelden(a.id, { vorlage, betreff, text, dateien: [...wahl] });
      fertig(r.karte, r.text);
    } catch (x) { setFehler(ausFehler(x)); } finally { setLaeuft(false); }
  }

  const untertitel = `${[a.strasse, a.hausnummer].filter(Boolean).join(' ')}, ${[a.plz, a.ort].filter(Boolean).join(' ')}${a.kls_id ? `, KLS ${a.kls_id}` : ''}`;
  return (
    <Dialog titel="Auftrag an Telekom melden" untertitel={untertitel} breite={640} laeuft={laeuft} zu={zu}>
      <Fehlerkasten lage={fehler} />
      {!d ? <div className="klein leise">Lädt …</div> : (
        <>
          {!d.postfach_da && (
            <div className="hinweis warnung" style={{ marginBottom: 10 }}>
              Postfach in der Konfiguration eintragen: NE4 › Konfiguration › Mails „NE4-Postfach der Telekom“. Bis dahin wird nichts gesendet.
            </div>
          )}
          <div className="feld"><label>Vorlage</label>
            <div className="vorlagenwahl">
              {d.vorlagen.map((v: any) => (
                <button key={v.schluessel} type="button" className="knopf klein" aria-pressed={vorlage === v.schluessel} onClick={() => nimmVorlage(v.schluessel)}>{v.titel}</button>
              ))}
            </div>
          </div>
          <div className="feld" style={{ marginTop: 10 }}><label>An</label><div>NE4-Postfach der Telekom <span className="klein leise">(aus der Konfiguration)</span></div></div>
          <Text name="betreff" titel="Betreff" wert={betreff} setze={setBetreff} fehler={fehler} pflicht />
          <Text name="text" titel="Text (änderbar)" wert={text} setze={setText} fehler={fehler} mehrzeilig zeilen={8} pflicht />
          <div className="feld" style={{ marginTop: 10 }}>
            <label>Anhänge ({gewaehlt.length} von {d.dateien.length}, {mb(summe)} von 20 MB)</label>
            {!d.dateien.length && <div className="klein leise">Am Haus liegen keine Dateien. Kundenmails im Reiter Dateien in „Kundenmails“ ziehen.</div>}
            {d.dateien.map((f: any) => (
              <label key={f.id} className="anhangzeile">
                <input type="checkbox" checked={wahl.has(f.id)} onChange={(e) => { const n = new Set(wahl); if (e.target.checked) n.add(f.id); else n.delete(f.id); setWahl(n); }} />
                <span>{f.mail_betreff ? `${f.mail_betreff} (Mail${f.mail_von ? ` von ${f.mail_von}` : ''}${f.mail_datum ? `, ${zeitpunkt(f.mail_datum)}` : ''})` : f.dateiname}
                  <br /><span className="klein leise">{f.ordner}, {mb(Number(f.groesse ?? 0))}</span></span>
              </label>
            ))}
            {zuGross && <div className="hinweis fehler">Zusammen mehr als 20 MB; bitte weniger Anhänge wählen.</div>}
          </div>
          {vorschau && (
            <div className="karte" style={{ marginTop: 10, padding: 12, whiteSpace: 'pre-wrap' }}>
              <div className="klein leise">An: NE4-Postfach der Telekom</div>
              <b>{betreff}</b>
              <div style={{ marginTop: 8 }}>{text}</div>
              {gewaehlt.length > 0 && <div className="klein leise" style={{ marginTop: 8 }}>Anhänge: {gewaehlt.map((f: any) => f.dateiname).join(', ')}</div>}
            </div>
          )}
          <div className="hinweis" style={{ marginTop: 10 }}>Nach dem Senden steht das Haus auf <b>Zurückgegeben</b>, mit Vermerk im Verlauf. Im Testmodus geht die Mail nur an die Testadresse, dann bleibt der Status.</div>
          <div className="reihe" style={{ marginTop: 12, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button type="button" className="knopf" onClick={zu}>Abbrechen</button>
            <button type="button" className="knopf" onClick={() => setVorschau(!vorschau)}>{vorschau ? 'Vorschau zu' : 'Vorschau'}</button>
            <button type="button" className="knopf haupt" disabled={laeuft || !d.postfach_da || zuGross || !betreff.trim() || !text.trim()} onClick={senden}>Senden</button>
          </div>
        </>
      )}
    </Dialog>
  );
}
